declare global {
  interface Window {
    // Set by customerHeader.twig: the load balancer cohort header, else the gp_rl cookie.
    relaunchTheme?: boolean;
  }
}

export const isRelaunchTheme = (): boolean => window.relaunchTheme === true;
